import type { ISODateTimeString } from '../BrandedTypes'

export const Ai = {
  PromptAssetAdded: 'AI.PromptLibrary.V1.PromptAssetAdded',
  PromptAssetUpdated: 'AI.PromptLibrary.V1.PromptAssetUpdated',
  PromptAssetRemoved: 'AI.PromptLibrary.V1.PromptAssetRemoved'
} as const

export type PromptAssetAddedSignalRPayload = {
  id: string
  occuredAt: ISODateTimeString
}

export type PromptAssetUpdatedSignalRPayload = {
  id: string
  occuredAt: ISODateTimeString
}

export type PromptAssetRemovedSignalRPayload = {
  id: string
  occuredAt: ISODateTimeString
}
